import { useApi } from "./api"
import { useMemo } from "react"

export function useClients(dataStatus: boolean) {
  const [response, error, loading, retry] = useApi("/clients/mine", {
    lazy: false,
    blockCall: dataStatus,
  })
  const data = useMemo(() => response?.data?.array ?? [], [response?.data?.array])
  return useMemo(() => [data, error, loading, retry], [data, error, loading, retry])
}

export interface Client {
  name: string
  uuid: string
  displayName: string
}
